import { Alert, Snackbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React from "react";

const StyledAlert = styled(Alert)(({ theme }) => ({
  width: "342px",
  height: "100%",
  flexDirection: "row",
  alignItems: "center",
  "&.MuiAlert-standardSuccess": {
    backgroundColor: "#43A047",
  },
  "&.MuiAlert-standardError": {
    backgroundColor: "#B00020",
  },
}));

function Toast({
  open,
  content,
  success,
  onClose,
  style,
  overrideDuration,
  severity,
}) {
  const DURATION = 2000;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    onClose();
  };

  return (
    <Snackbar
      open={Boolean(open)}
      autoHideDuration={overrideDuration || DURATION}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <StyledAlert
        severity={success ? "success" : severity || "error"}
        style={style || {}}
        elevation={6}
        variant="filled"
      >
        {content}
      </StyledAlert>
    </Snackbar>
  );
}

Toast.prototype = {
  title: PropTypes.string.isRequired,
  error: PropTypes.bool,
  success: PropTypes.bool,
  onClose: PropTypes.func,
  style: PropTypes.object,
  overrideDuration: PropTypes.number,
  content: PropTypes.string,
};

export default Toast;
